jQuery(function () {
  const domReady = (cb) => {
    if (typeof wp !== "undefined" && wp.domReady) wp.domReady(cb);
    else cb();
  };

  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };
    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  const isEditor = () => {
    if (document.body && document.body.classList.contains("block-editor-page"))
      return true;
    if (window.wp && window.wp.data && window.wp.data.select) {
      try {
        if (window.wp.data.select("core/edit-post")) return true;
      } catch (e) {}
    }
    return false;
  };

  domReady(() => {
    if (isEditor()) return;

    whenGsapReady(() => {
      whenScrollReady(() => {
        initProductCards();
      });
    });
  });

  function initProductCards() {
    const blocks = document.querySelectorAll(".product-cards");
    if (!blocks.length) return;

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    if (reduceMotion) return;

    const gsap = window.gsap;
    if (!gsap) return;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    blocks.forEach((block) => {
      if (block.dataset.pcInit === "1") return;
      block.dataset.pcInit = "1";

      const title = block.querySelector(".product-cards__title");
      const svg = block.querySelector(".product-cards__svg");
      const cards = block.querySelectorAll(".product-card");

      const headEls = [];
      if (title) headEls.push(title);
      if (svg) headEls.push(svg);

      if (headEls.length) gsap.set(headEls, { autoAlpha: 0, y: 14 });
      if (cards.length)
        gsap.set(cards, {
          autoAlpha: 0,
          y: 26,
          rotateX: 6,
          transformPerspective: 800,
        });

      const anim = () => {
        const tl = gsap.timeline({
          defaults: { ease: "power3.out" },
        });

        if (headEls.length) {
          tl.to(
            headEls,
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.9,
              stagger: 0.08,
              clearProps: "transform",
            },
            0,
          );
        }

        if (cards.length) {
          tl.to(
            cards,
            {
              autoAlpha: 1,
              y: 0,
              rotateX: 0,
              duration: 1.05,
              stagger: 0.12,
              clearProps: "transform",
            },
            headEls.length ? 0.12 : 0,
          );
        }

        if (cards.length) {
          tl.fromTo(
            cards,
            {
              filter: "blur(6px)",
            },
            {
              filter: "blur(0px)",
              duration: 0.9,
              stagger: 0.12,
              ease: "power2.out",
              clearProps: "filter",
            },
            headEls.length ? 0.14 : 0.02,
          );
        }

        return tl;
      };

      if (ScrollTrigger) {
        ScrollTrigger.create({
          trigger: block,
          start: "top 78%",
          once: true,
          invalidateOnRefresh: true,
          onEnter: () => anim(),
        });
      } else {
        anim();
      }
    });
  }
});
